import React from "react";
import "common/styles/components/loading-spinner.css";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner"></div>
      <p>読み込み中...</p>
    </div>
  );
};

export default LoadingSpinner;
